import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {isEmptyString, isValidNumber} from '../../../utils/validator';
import {useFormErrors} from '../../hooks/useFormErrors';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {DatePickerCustom, InputPercent, InputLista, InputEntidad, InputPersona} from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel} from "../../common";

const VinculoInmuebleModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        idTipoVinculoInmueble: 0,
        idPersona: 0,
        idTipoPersona: 0,
        idTipoDocumento: 0,
        numeroDocumento: "",
        nombrePersona: "",
        idTipoInstrumento: 0,
        fechaInstrumentoDesde: null,
        fechaInstrumentoHasta: null,
        porcentajeCondominio: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });
    const [persona, setPersona] = useState({
        idTipoPersona: 0,
        idTipoDocumento: 0,
        numeroDocumento: "",
        nombrePersona: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity}
        });
        setPersona({
            idTipoPersona: props.data.entity.idTipoPersona,
            idTipoDocumento: props.data.entity.idTipoDocumento,
            numeroDocumento: props.data.entity.numeroDocumento,
            nombrePersona: props.data.entity.nombrePersona
        });
        formSet({
            idTipoVinculoInmueble: props.data.entity.idTipoVinculoInmueble,
            idPersona: props.data.entity.idPersona,
            idTipoInstrumento: props.data.entity.idTipoInstrumento,
            fechaInstrumentoDesde: props.data.entity.fechaInstrumentoDesde,
            fechaInstrumentoHasta: props.data.entity.fechaInstrumentoHasta,
            porcentajeCondominio: props.data.entity.porcentajeCondominio
        });
    }
    useEffect(mount, [props.data.entity]);


    const [formValues, formHandle, , formSet] = useForm({
        idTipoVinculoInmueble: 0,
        idPersona: 0,
        idTipoInstrumento: 0,
        fechaInstrumentoDesde: null,
        fechaInstrumentoHasta: null,
        porcentajeCondominio: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoVinculoInmueble = parseInt(formValues.idTipoVinculoInmueble);
        row.idPersona = parseInt(formValues.idPersona);
        row.idTipoPersona = persona.idTipoPersona;
        row.idTipoDocumento = persona.idTipoDocumento;
        row.numeroDocumento = persona.numeroDocumento;
        row.nombrePersona = persona.nombrePersona;
        row.idTipoInstrumento = !isEmptyString(formValues.idTipoInstrumento) ? parseInt(formValues.idTipoInstrumento) : 0;
        row.fechaInstrumentoDesde = formValues.fechaInstrumentoDesde;
        row.fechaInstrumentoHasta = formValues.fechaInstrumentoHasta;
        row.porcentajeCondominio = formValues.porcentajeCondominio;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoVinculoInmueble <= 0) errors.idTipoVinculoInmueble = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idPersona <= 0) errors.idPersona = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.porcentajeCondominio, false)) errors.porcentajeCondominio = VALIDATION_MESSAGE.REQUIRED_SHORT;

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Persona del inmueble: ${(state.entity.id > 0) ? state.entity.nombrePersona : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.VINCULO_INMUEBLE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalles del vínculo" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-4">
                                                <FormLabel htmlFor="idTipoVinculoInmueble" required>Tipo</FormLabel>
                                                <InputLista
                                                    name="idTipoVinculoInmueble"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoVinculoInmueble') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoVinculoInmueble}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoVinculoInmueble"
                                                />
                                                <FormError message={errorOf('idTipoVinculoInmueble')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-8">
                                                <FormLabel htmlFor="idPersona" required>Persona</FormLabel>
                                                <InputPersona
                                                    name="idPersona"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idPersona') ? 'is-invalid' : ''}`}
                                                    value={formValues.idPersona}
                                                    idTipoPersona={0}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const persona = (target.row) ? {
                                                            idTipoPersona: target.row.idTipoPersona,
                                                            idTipoDocumento: target.row.idTipoDocumento,
                                                            numeroDocumento: target.row.numeroDocumento,
                                                            nombrePersona: target.row.nombrePersona
                                                        } : {
                                                            idTipoPersona: 0,
                                                            idTipoDocumento: 0,
                                                            numeroDocumento: "",
                                                            nombrePersona: ""
                                                        };
                                                        setPersona(persona);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idPersona')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-4">
                                                <label htmlFor="idTipoInstrumento" className="form-label">Tipo
                                                    instrumento</label>
                                                <InputEntidad
                                                    name="idTipoInstrumento"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.TIPO_INSTRUMENTO_MODAL}
                                                    className="form-control"
                                                    value={formValues.idTipoInstrumento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo de instrumento"
                                                    entidad="TipoInstrumento"
                                                    onFormat={(row) => (row) ? row.nombre : ''}
                                                    columns={[
                                                        {Header: 'Nombre', accessor: 'nombre', width: '95%'}
                                                    ]}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaInstrumentoDesde"
                                                       className="form-label">Presentación</label>
                                                <DatePickerCustom
                                                    name="fechaInstrumentoDesde"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaInstrumentoDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaInstrumentoHasta" className="form-label">Vigencia
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaInstrumentoHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaInstrumentoHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaInstrumentoDesde}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-2">
                                                <FormLabel htmlFor="porcentajeCondominio" required>Condominio</FormLabel>
                                                <InputPercent
                                                    name="porcentajeCondominio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('porcentajeCondominio') ? 'is-invalid' : ''}`}
                                                    value={formValues.porcentajeCondominio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('porcentajeCondominio')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de vínculo inmueble"
                                            processKey={props.processKey}
                                            entidad="VinculoInmueble"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

VinculoInmuebleModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

VinculoInmuebleModal.defaultProps = {
    disabled: false
};

export default VinculoInmuebleModal;